import script from "./AskBoard.vue?vue&type=script&lang=ts&setup=true"
export * from "./AskBoard.vue?vue&type=script&lang=ts&setup=true"

import "./AskBoard.vue?vue&type=style&index=0&id=659c13a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659c13a8"]])

export default __exports__